@if (isLoading) {
<h2 class="panel-title-dummy">
    <div class="shine"></div>
</h2>
<div class="panel-dummy">
    <div class="shine"></div>
</div>
<div class="panel-dummy">
    <div class="shine"></div>
</div>
}
@else {
<h2 class="panel-title">{{ 'Modules.MapView.Title' | translate }}</h2>

<div class="map" leaflet [leafletOptions]="options" [leafletLayers]="getLayers()">
</div>
<p class="p-formfield-info">{{ 'Modules.MapView.MapInfo' | translate }}</p>
<form class="form-container" [formGroup]="filterForm">
    <app-input formControlName="enableClustering" type="switch"
        label="{{ 'Modules.MapView.EnableClustering' | translate }}"></app-input>
    <app-input formControlName="includeCcaps" type="switch"
        label="{{ 'Modules.MapView.IncludeCcaps' | translate }}"></app-input>
</form>
}